export default __webpack_public_path__ + "static/media/secure.8d600d1a.svg";